<template>
	<v-container>
		<common-table
			:options.sync="tableOptions"
			:headers="headers"
			:items="warehouses"
			:items-length="warehouses.length"
			:items-per-page="tableOptions.itemsPerPage"
			:items-per-page-options="tableFooterProps.itemsPerPageOptions"
			hide-default-footer
			style="cursor: pointer"
			disable-sort
			@row-click="showDialog"
			@delete-item="deleteWarehouse"
		/>
		<v-btn class="mt-6" color="accent" outlined large elevation="0" @click="showDialog(null)">
			<v-icon class="icon-plus mr-2" start size="medium"></v-icon>
			{{ $t("add_new_warehouse") }}
		</v-btn>
		<warehouse-dialog
			:key="dialog.item ? dialog.item.id || dialog.item._id || 'new' : 'new'"
			v-model="dialog.visibility"
			:item="dialog.item"
			@saved="dialogSaved"
		/>
	</v-container>
</template>

<script>
import uiMixin from "../../../store/interfaces/ui.mixin";
import remote from "../../../data/remote";
import WarehouseDialog from "./dialogs/WarehouseDialog.vue";
import CommonTable from "../../partials/CommonTable.vue";
import { mapGetters } from "vuex";

export default {
	mixins: [uiMixin],
	components: { WarehouseDialog, CommonTable },
	data() {
		return {
			tableOptions: { itemsPerPage: 10 },
			tableFooterProps: { itemsPerPageOptions: [5, 10, 15, 20] },
			loading: true,
			warehouses: [],
			headers: [
				{ text: this.$t("name"), value: "name" },
				{ text: this.$t("address"), value: "address" },
				{ text: this.$t("phone_number"), value: "phoneNumber" },
				{ text: this.$t("mobile_number"), value: "mobileNumber" },
				{ text: this.$t("email"), value: "email" },
				{ text: this.$t("actions"), value: "actions" },
			],
			dialog: {
				visibility: false,
				item: null,
			},
		};
	},
	computed: {
		...mapGetters(["company"]),
	},
	methods: {
		loadItems() {
			this.loading = true;
			remote.warehouses.filter(this.company.id, {
				onSuccess: (result) => {
					this.warehouses = result;
					this.warehouses.forEach((w) => (w.id = w._id));
					this.loading = false;
				},
				onFail: (error) => {
					if (error) console.error(error);
					this.loading = false;
				},
			});
		},
		showDialog(warehouse) {
			this.dialog.item = warehouse ? { ...warehouse } : null;
			this.$nextTick(() => {
				this.dialog.visibility = true;
			});
		},
		hideDialog() {
			this.dialog.item = null;
			this.dialog.visibility = false;
		},
		dialogSaved() {
			this.hideDialog();
			this.loadItems();
		},
		deleteWarehouse(row) {
			this.showConfirmDialog({
				message: this.$t("delete_confirm_message"),
				onConfirm: () => {
					this.showProgressDialog();
					remote.warehouses.delete(this.company.id, row.id, {
						onSuccess: () => {
							this.hideProgressDialog();
							this.showSnackBar({ message: this.$t("$message.deleted", { item: this.$t("warehouse") }) });
							this.loadItems();
						},
						onFail: () => {
							this.hideProgressDialog();
						},
					});
				},
			});
		},
	},
	created() {
		this.loadItems();
	},
};
</script>
